import { render, staticRenderFns } from "./PartnerCreate.vue?vue&type=template&id=912d9532&scoped=true"
import script from "./PartnerCreate.vue?vue&type=script&lang=js"
export * from "./PartnerCreate.vue?vue&type=script&lang=js"
import style0 from "./PartnerCreate.vue?vue&type=style&index=0&id=912d9532&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912d9532",
  null
  
)

export default component.exports